import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '../../atoms/text'
import {
  StyledChevronRight,
  StyledContainer,
  StyledContent,
  StyledTagWrapper,
  StyledWrapper,
} from './styles'
import { BankAccountStatusIcon } from '../../atoms/BankAccountStatusIcon'
import icon_right_chevron from '../../../images/account-overview/right_arrow_icon.svg'
import { Tag } from '../../atoms/tag'
import { If } from '../../atoms/if'
import { DeleteButton } from '../../atoms/DeleteButton'
import { useTranslation } from '../../../context/translationProvider'

export const MyAccountBankAccountCard = ({
  active = true,
  isDefault = false,
  bankAccount = {},
  tagLabel = '',
  onClick = () => {},
  onDelete = () => {},
}) => {
  const { translate } = useTranslation()

  const handleClick = (event) => {
    event.stopPropagation()
    onClick({ bankAccount, isActive: active })
  }

  const handleDelete = (event) => {
    event.stopPropagation()
    onDelete({ bankAccount, isActive: active })
  }

  return (
    <StyledContainer onClick={handleClick}>
      <StyledWrapper>
        <div>
          <BankAccountStatusIcon active={active} />
        </div>
        <StyledContent>
          <div>
            <Text bold style={{ marginBottom: 5, lineHeight: '26px' }}>
              {bankAccount.bank.name}
            </Text>
            <Text small style={{ marginBottom: 4 }}>
              Ag {bankAccount.bankBranch} | {bankAccount.accountNumber}
            </Text>
            <Text small style={{ marginBottom: 5 }}>
              {bankAccount.accountType}
            </Text>
            <StyledTagWrapper>
              <If
                condition={isDefault}
                render={() => (
                  <Tag
                    theme="secondary"
                    text={translate('payments.bankAccountKeys.tags.default')}
                  />
                )}
              />
              <Tag theme="grey" text={tagLabel} />
            </StyledTagWrapper>
            <If
              condition={!active}
              render={() => <DeleteButton onDelete={handleDelete} />}
            />
          </div>
        </StyledContent>
      </StyledWrapper>
      <StyledChevronRight src={icon_right_chevron} alt="Right arrow" />
    </StyledContainer>
  )
}

MyAccountBankAccountCard.propTypes = {
  onClick: PropTypes.func,
  active: PropTypes.bool,
  isDefault: PropTypes.bool,
  tagLabel: PropTypes.string,
  onDelete: PropTypes.func,
  bankAccount: PropTypes.shape({
    bankBranch: PropTypes.string,
    accountNumber: PropTypes.string,
    accountType: PropTypes.string,
    bank: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
}
